//@flow
import React, { Component } from 'react';
import { Tablet, Mobile } from '../../Responsive';
import { CustomModelListTh } from '../StatisticsStyles';

type Props = {
  options: Array<any>
};

export default class TableHeaderDeviceRow2 extends Component<Props> {
  render() {
    // $FlowFixMe
    return this.props.options.map(item => (
      <>
        <Tablet>
          <CustomModelListTh right={item.right}>{item.lg}</CustomModelListTh>
        </Tablet>
        {item.sm && (
          <Mobile>
            <CustomModelListTh right={item.right}>{item.sm}</CustomModelListTh>
          </Mobile>
        )}
      </>
    ));
  }
}
